exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".self{border:1px solid #ffa39e;background-color:#fff1f0;border-radius:5px}.edm,.self{padding:3px 7px}.edm{border:1px solid #91d5ff;background-color:#e6f7ff;border-radius:5px}.p{line-height:22px;margin:14px 0 6px 0}.list{margin-top:5px}.list:last-child{margin-bottom:14px}", ""]);

// exports
